import React from 'react';


class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, error: null, errorInfo: null };
    }
  
    static getDerivedStateFromError(error) {
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can log the error to an error reporting service
      console.error("Error caught by ErrorBoundary:", error, errorInfo);
      this.setState({ error, errorInfo });
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
          <div>
            <h1>Something went wrong.</h1>
            {/* <p>{this.state.error && this.state.error.toString()}</p>
            <p>{this.state.errorInfo && this.state.errorInfo.componentStack}</p> */}
          </div>
        );
      }
  
      return this.props.children;
    }
  }



  export default ErrorBoundary;